/**
 * User-visible copy for multi-instance Large UPS list + per-unit editor (#996 Phase 4).
 * Mirrors coolingSystemConfigurationsSubsectionCopy.
 */

export const LARGE_UPS_EMPTY_STATE_TITLE = 'No Large UPS added yet';

export const LARGE_UPS_CONFIGURATIONS_LIST_TITLE = 'Large UPS units';

export const LARGE_UPS_CONFIGURATIONS_LIST_SUBTITLE =
  'Each row is one large UPS configuration. Select a row to edit, or add a new unit below.';

export const LARGE_UPS_EDIT_DETAILS_CARD_SUBTITLE =
  'Description, model, redundancy, battery chemistry, and runtime for this large UPS.';

/** Standalone Large UPS step — unit editor Additional Information (#997 / #1330). */
export const LARGE_UPS_ADDITIONAL_INFORMATION_SUBTITLE =
  'Extra notes or attachments for this large UPS unit.';

export const LARGE_UPS_ADDITIONAL_INFORMATION_LABEL =
  'Additional Large UPS Information';

export const LARGE_UPS_ADDITIONAL_INFORMATION_PLACEHOLDER =
  'Enter additional large UPS information';

export const LARGE_UPS_EDIT_ALL_UNITS_LABEL = 'All Large UPS';

export const LARGE_UPS_EDIT_HEADER_TITLE_NEW = 'New Large UPS';

export const LARGE_UPS_EDIT_STATUS_EXISTING_LABEL = 'Existing';

export const LARGE_UPS_EDIT_STATUS_NEW_LABEL = 'New';

export const LARGE_UPS_EDIT_TYPE_LABEL = 'Large UPS type';

/** Display labels for {@link FormTwoOptionChoice} — map to `status` existing | new. */
export const LARGE_UPS_EDIT_TYPE_OPTIONS = [
  LARGE_UPS_EDIT_STATUS_EXISTING_LABEL,
  LARGE_UPS_EDIT_STATUS_NEW_LABEL,
] as const;

export const LARGE_UPS_EDIT_DELETE_LABEL = 'Delete';

export const LARGE_UPS_EDIT_SAVE_LABEL = 'Save Large UPS';

/** Create Request / draft flow — clarifies save is local to the step list. */
export const LARGE_UPS_EDIT_SAVE_DRAFT_LABEL = 'Save Large UPS';

export const LARGE_UPS_EDIT_SAVE_DRAFT_HINT =
  'Adds this unit to the list. Save the request separately when ready.';

export const LARGE_UPS_ROW_ACTION_EDIT_LABEL = 'Edit';

export const LARGE_UPS_ROW_ACTION_VIEW_LABEL = 'View';

export const LARGE_UPS_ROW_ACTION_DUPLICATE_LABEL = 'Duplicate';

/** List row overflow menu — short action labels (editor footer uses {@link LARGE_UPS_EDIT_DELETE_LABEL}). */
export const LARGE_UPS_ROW_ACTION_DELETE_LABEL = 'Delete';

export const LARGE_UPS_DELETE_CONFIRM_TITLE = 'Delete Large UPS Configuration';

export const LARGE_UPS_DELETE_CONFIRM_MESSAGE =
  'Are you sure you want to delete this large UPS configuration? This cannot be undone.';

export const LARGE_UPS_DISCARD_UNSAVED_TITLE = 'Unsaved Changes';

export const LARGE_UPS_DISCARD_UNSAVED_MESSAGE =
  'You have unsaved changes. Discard them?';

export const LARGE_UPS_DISCARD_UNSAVED_KEEP_EDITING_LABEL = 'Stay';

export const LARGE_UPS_DISCARD_UNSAVED_DISCARD_LABEL = 'Discard';
